import type { MessageDescriptor } from 'react-intl';
import type {
  OutreachContactKind,
  OutreachPointSource,
  OutreachTargetKind,
  OutreachWorkspaceContactStatus,
} from 'fym-shared/src/music24/outreach/types';
import { outreachMessages as m } from './outreachMessages';

/** The labels of the Outreach enums. Unknown values (a newer server) fall back to a neutral label. */

export const TARGET_KIND_LABEL: Record<OutreachTargetKind, MessageDescriptor> = {
  playlist: m.kindPlaylist,
  press: m.kindPress,
  newsletter: m.kindNewsletter,
  radio: m.kindRadio,
  podcast: m.kindPodcast,
  creator: m.kindCreator,
  community: m.kindCommunity,
};

export const CONTACT_KIND_LABEL: Record<OutreachContactKind, MessageDescriptor> = {
  curator: m.contactKindCurator,
  outlet: m.contactKindOutlet,
  creator: m.contactKindCreator,
  private: m.contactKindPrivate,
};

export const CONTACT_STATUS_LABEL: Record<OutreachWorkspaceContactStatus, MessageDescriptor> = {
  new: m.statusNew,
  pitched: m.statusPitched,
  replied: m.statusReplied,
  placed: m.statusPlaced,
  doNotContact: m.statusDoNotContact,
};

const POINT_SOURCE_LABEL: Record<OutreachPointSource, MessageDescriptor> = {
  playlistDescription: m.sourcePlaylistDescription,
  website: m.sourceWebsite,
  linkInBio: m.sourceLinkInBio,
  instagramPublic: m.sourceInstagramPublic,
  youtubeAbout: m.sourceYoutubeAbout,
  soundcloud: m.sourceSoundcloud,
  bandcamp: m.sourceBandcamp,
  webSearch: m.sourceWebSearch,
  newsletterIndex: m.sourceNewsletterIndex,
  podcastIndex: m.sourcePodcastIndex,
  podcastFeed: m.sourcePodcastFeed,
  tiktokPublic: m.sourceTiktokPublic,
  redditAbout: m.sourceRedditAbout,
  import: m.sourceImport,
  admin: m.sourceAdmin,
};

export function pointSourceLabel(source: string): MessageDescriptor {
  return POINT_SOURCE_LABEL[source as OutreachPointSource] ?? m.sourceAdmin;
}

export function contactStatusLabel(status: string): MessageDescriptor {
  return CONTACT_STATUS_LABEL[status as OutreachWorkspaceContactStatus] ?? m.statusNew;
}

export function contactKindLabel(kind: string): MessageDescriptor {
  return CONTACT_KIND_LABEL[kind as OutreachContactKind] ?? m.contactKindCurator;
}
